var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.base}`},[(_vm.title)?_c('WorkflowSectionTitle',{class:`${_vm.base}__header`,attrs:{"title":_vm.title,"icon":_vm.icon,"info":_vm.info}}):_vm._e(),_c('div',{class:`${_vm.base}__input`},[_vm._t("input")],2),(_vm.footerText)?_c('div',{class:[`${_vm.base}__footer`, 'mt-1']},[_vm._v(" "+_vm._s(_vm.footerText)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }